export default {
    findPagamento: { 
        url: 'dividas/{divida_id}/pagamento', 
        method: 'get', 
    },
    finishAcordo: {
        url: 'acordos', 
        method: 'post', 
    }
}